export default __webpack_public_path__ + "static/media/poster-1-mini.abda7211.png";